import { render, staticRenderFns } from "./LegalData.vue?vue&type=template&id=6727d8e8&"
import script from "./LegalData.vue?vue&type=script&lang=js&"
export * from "./LegalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports